import React, { useEffect, useState } from "react";
import logo from "../../../public/logo.png";
import isiLogo from "../../../public/isi-logo.png";
import Layout from "../../Components/Navigation/Layout";
import axios from "axios";

export default function GoldRateDisplay() {
  const [rates, setRates] = useState({});
  const [message, setMessage] = useState("");

  const currentDate = new Date().toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  useEffect(() => {
    const fetchRates = async () => {
      const userStr = localStorage.getItem("user");
      if (!userStr) return;
      const user = JSON.parse(userStr);
      if (!user || !user.Email) return;

      const { data } = await axios.get(
        `/server/baos_function/getRates/${user.Email}`
      );
      const jewelRate = data?.data?.[0]?.Jewel_Rate;
      if (jewelRate) {
        setRates(jewelRate);
        setMessage(jewelRate.Message);
      }
    };
    fetchRates();
  }, []);

  const rateLabels = [
    { label: "item1", price: "item1_Price" },
    { label: "item2", price: "item2_Price" },
    { label: "item3", price: "item3_Price" },
    { label: "item4", price: "item4_Price" },
    { label: "item5", price: "item5_Price" },
    { label: "item6", price: "item6_Price" },
    { label: "item7", price: "item7_Price" },
  ];

  return (
    <Layout style={{ margin: 0 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "black",
          overflow: "hidden",
          margin: 0,
          padding: 0,
        }}
      >
        <div className="digital-board">
          <div className="watermark">BOAS</div>

          {/* Header */}
          <div className="header">
            <div className="top-bar">
              <div className="logo-container">
                <img src={isiLogo} alt="ISI Logo" className="isi-logo" />
              </div>
              <div className="top-center">
                <div className="shop-name">{rates.Shop_Name}</div>
                <div className="date">{currentDate}</div>
              </div>
              <div className="logo-container" /> {/* Empty for spacing */}
            </div>
          </div>

          {/* Scroll Text */}
          <div className="scroll-container">
            <div className="scroll-text">{rates.Message}</div>
          </div>

          <div className="rate-section">
            {rateLabels.map(({ label, price }) => (
              <div className="rate-row" key={label}>
                <div className="rate-type">{rates[label]}</div>
                <div className="rate-value">₹ {rates[price]}</div>
              </div>
            ))}
          </div>

          {/* Footer */}
          <div className="footer">
            BOAS 
          </div>
        </div>
      </div>

      <style jsx>{`
        @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap");

        html,
        body {
          margin: 0;
          padding: 0;
          background: black;
          height: 100vh;
          width: 100vw;
          overflow: hidden;
          font-family: "Inter", sans-serif;
        }

        .screen-wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
          width: 100vw;
          overflow: hidden; /* Prevent scrolling */
          padding: 0; /* Remove extra padding */
          box-sizing: border-box;
        }

        .digital-board {
          background: #111;
          border: 10px solid #facc15;
          box-shadow: 0 0 15px #facc15;
          position: relative;
          width: 95vw;
          height: 95vh;
          max-width: 1000px;
          max-height: 680px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 1rem;
          box-sizing: border-box;
          overflow: hidden;
        }

        .watermark {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 6rem;
          font-weight: bold;
          color: rgba(255, 255, 255, 0.035);
          pointer-events: none;
          z-index: 0;
        }

        .header {
          z-index: 1;
        }

        .top-bar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: relative;
        }

        .logo-container {
          width: 100px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .isi-logo {
          height: 80px;
        }

        .top-center {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          width: 100%;
          text-align: center;
        }

        .shop-name {
          font-size: 2.2rem;
          font-weight: bold;
          color: #facc15;
        }

        .date {
          font-size: 1.4rem;
          font-weight: bold;
          color: #60a5fa;
          margin-top: 0.25rem;
        }

        .scroll-container {
          margin: 1rem 0;
          height: 1.5rem;
          overflow: hidden;
        }

        .scroll-text {
          white-space: nowrap;
          display: inline-block;
          animation: marquee 18s linear infinite;
          font-size: 1rem;
          font-weight: bold;
          color: #facc15;
        }

        @keyframes marquee {
          0% {
            transform: translateX(100%);
          }
          100% {
            transform: translateX(-100%);
          }
        }

        .rate-section {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 0.5rem;
          z-index: 1;
        }

        .rate-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: black;
          border: 2px solid #0f0;
          padding: 0.6rem 1.2rem;
          font-family: "Inter", sans-serif;
          font-size: 1.4rem;
          color: #00ff00;
          box-shadow: 0 0 6px #00ff00;
          border-radius: 8px;
        }

        .rate-type {
          color: #facc15;
        }

        .footer {
          text-align: center;
          font-size: 0.95rem;
          color: #facc15;
          border-top: 2px solid #facc15;
          padding-top: 0.4rem;
          z-index: 1;
        }

        @media (max-width: 768px) {
          .shop-name {
            font-size: 1.4rem;
          }

          .date {
            font-size: 1.2rem;
          }

          .isi-logo {
            height: 60px;
          }

          .rate-row {
            font-size: 1.1rem;
            padding: 0.4rem 1rem;
          }

          .scroll-text {
            font-size: 0.85rem;
          }

          .footer {
            font-size: 0.8rem;
          }
        }
      `}</style>
    </Layout>
  );
}
